import React, { useEffect, useState } from 'react'
import Pagination from 'react-js-pagination'
import { useSearchParams } from 'react-router-dom'
import { IoSearch } from 'react-icons/io5'

import NotFound from '../../../components/not-found/NotFound'
import useFullPageLoader from '../../../hooks/useFullPageLoader'
// import useDebounce from '../../../hooks/useDebounce'
// import { getLocalStorage, setLocalStorage } from '../../../config/config'
import { toastMessage } from '../../../utils/toastMessage'
import common from '../../../routes/common'
import { dateFormat, dateFormatWithTime, monthFormat, } from '../../../utils/dateFormat'
import scrollToUp from '../../../utils/scrollToUp'
import { getbeforeConsultantPayoutApi, getConsultantPayoutForExactMonthApi, getSettlementLogs, uploadExcelWithSettlement, updateSettlementRows, setWalletPayoutVisibility } from '../../../services/consultantPayout'
import { Button, CircularProgress } from '@mui/material'
import useDownloadWithPassword from '../../../hooks/useDownloadWithPassword'
import constants from '../../../utils/constants'
import { payoutNativeBtnStyle, SettlementSheetLink } from './commons'

const { NOT_FOUND } = common;

/** Base URL often ends with `/api/` — avoid `.../api//admin/...` when appending paths */
function buildAdminApiUrl(path) {
    // const base = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '
    const base = constants.SERVER_API;
    const segment = String(path || '').replace(/^\/+/, '');
    return `${base}/${segment}`;
}

export const ConsultantPayoutCurrentMonthCMP = () => {

    const [searchParam, setSearchParam] = useSearchParams();
    const { loading: exportbuttonLoader, requestDownload, DownloadPasswordModal } = useDownloadWithPassword()

    // let activePage = +searchParam.get('page') || 1
    const [activePage, setActivePage] = useState(1)

    const [search, setSearch] = useState('')

    // const debounceValue = useDebounce(search || '', 300)
    const [total, setTotal] = useState(0)
    const [payoutList, setPayoutList] = useState([])
    const fromDate = searchParam.get('fromDate') || '';
    const toDate = searchParam.get('toDate') || '';

    // useEffect(() => {
    //     setLocalStorage('payoutList', 'search', search)
    // }, [search])

    const [loader, showLoader, hideLoader] = useFullPageLoader()

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        setActivePage(event)
    }

    const handleExcelDownload = () => {
        const url = buildAdminApiUrl('admin/payout/export')
        const params = {}
        requestDownload(url, `current-month-payout-${dateFormat(new Date())}`, params)
    }

    //------------------consultant payout -listing-Api----------------------------------
    const getpayoutList = async () => {
        try {
            showLoader()
            const sendData = {
                page: activePage,
                limit: '10',
            }
            if (search) {
                sendData.search = search
                sendData.page = 1
            }
            if (fromDate) {
                sendData.fromDate = fromDate
                sendData.page = 1
            }
            if (toDate) {
                sendData.toDate = toDate
                sendData.page = 1
            }

            const response = await getbeforeConsultantPayoutApi(sendData)
            console.log(response)
            const data = response.data

            // const { data } =
            if (data.code === 200) {
                setPayoutList(data?.result?.finalList || [])
                setTotal(data?.result?.total || 0)
                scrollToUp()
            } else {
                setPayoutList([])
                setTotal(0)
                toastMessage(data.message, 'error', 'payoutList')
            }
        } catch (error) {
            setPayoutList([])
            setTotal(0)
            toastMessage(error?.message || 'Something went wrong!', 'error', 'payoutList')
            console.log('error', error)
        } finally {
            hideLoader()
        }
    }

    useEffect(() => {
        getpayoutList()
    }, [search, fromDate && toDate, activePage])

    return (
        <>
            {loader}
            <div className="">
                <div className="FilterBox FilterArea">
                    <div className="form-group search_lg_size userSearch">
                        <input
                            type="search"
                            className={`form-control ${search && 'active'}`}
                            placeholder="Search"
                            value={search || ''}
                            style={{ '--color': '#FF8989' }}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <span className="user_search_icon">
                            <IoSearch />
                        </span>
                    </div>
                    {exportbuttonLoader ?
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: '600' }}>
                            <CircularProgress size={15} />
                            <span>Fetching, Converting, Downloading...</span>
                        </div> : <Button variant="contained" color="success" onClick={handleExcelDownload} >Download Current Payout</Button>}
                </div>
                <div className="content-table">
                    <table>
                        <thead>
                            <tr>
                                <th>USER ID</th>
                                <th>USER NAME</th>
                                <th>BANK NAME</th>
                                <th>PAY MONTH</th>
                                <th>AC_NO.</th>
                                <th>IFSC CODE</th>
                                <th>AMOUNT F</th>
                                <th>PAY DATE</th>
                                <th>PAY_UTR/REF NO.</th>
                                <th>REMARKS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payoutList.length > 0 ? (
                                payoutList.map((user, index) => {
                                    return <tr key={user?.createdAt}>
                                        <td>{user?.userId || user?.consultantUserId || user?.consultantId || '---'}</td>
                                        <td>{user.name || '---'}</td>
                                        <td>{user?.bankName || '---'}</td>
                                        <td>{user?.monthOfPayOut || user?.period || monthFormat(user?.paymentDate) || '---'}</td>
                                        <td>{user?.accountNumber || '---'}</td>
                                        <td>{user?.ifsc || '---'}</td>
                                        <td>{roundedAmountWithInr(user?.coins)}</td>
                                        <td>{dateFormatWithTime(user?.payOutDate) || '---'}</td>
                                        <td>{user?.transactionId || '---'}</td>
                                        <td>{user?.remarks || '---'}</td>
                                    </tr>
                                })
                            ) : (
                                <NotFound
                                    cols={10}
                                    msg="Payout not found!"
                                    icon={NOT_FOUND}
                                    loader={loader}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
                {total > 10 ? (
                    <div className="pagination-wrapper">
                        <div className="Pagination">
                            <Pagination
                                activePage={activePage}
                                previousLabel={'previous'}
                                nextLabel={'next'}
                                itemsCountPerPage={10}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                hideDisabled={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
            <DownloadPasswordModal />
        </>
    )
}

const PAYOUT_MONTH_PAGE_SIZE = 50;

const amountWithInr = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? `${amount.toFixed(2)} INR` : '---';
};

const signedAmountWithInr = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '---';
    if (amount === 0) return '0.00 INR';
    return `${amount > 0 ? '+' : ''}${amount.toFixed(2)} INR`;
};

const adjustmentColor = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount) || amount === 0) return '#64748b';
    return amount > 0 ? '#d97706' : '#be123c';
};

const adjustmentHint = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount) || amount === 0) return '';
    return amount > 0 ? 'add next month' : 'deduct next month';
};

const roundPayoutRupee = (value) => {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount)) return 0;
    const base = Math.trunc(amount);
    const paise = Math.abs(amount - base);
    return paise > 0.5 ? base + Math.sign(amount) : base;
};

const roundedAmountWithInr = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? `${roundPayoutRupee(amount)} INR` : '---';
};

const toDateInput = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    const tzOffset = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - tzOffset).toISOString().slice(0, 10);
};

const fromDateInput = (value) => {
    if (!value) return '';
    const parts = String(value).split('-');
    if (parts.length !== 3) return value;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

export const ConsultantPayoutMonthCMP = ({ selectedMonth, walletVisibility, onWalletVisibilityChange }) => {

    const [searchParam, setSearchParam] = useSearchParams()
    // let activePage = +searchParam.get('page') || 1;
    const [activePage, setActivePage] = useState(1)

    const [search, setSearch] = useState('')

    const [total, setTotal] = useState(0)
    const [payoutList, setPayoutList] = useState([])
    const fromDate = searchParam.get('fromDate') || '';
    const toDate = searchParam.get('toDate') || '';
    const [settelmentInfo, setSettelmentInfo] = useState(null);
    const [settlementLogs, setSettlementLogs] = useState([]);
    const [settlementLogsLoading, setSettlementLogsLoading] = useState(false);
    const [expandedLogId, setExpandedLogId] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [drafts, setDrafts] = useState({});
    const [savingRowId, setSavingRowId] = useState('');
    const [savingAll, setSavingAll] = useState(false);
    const [replacingSheet, setReplacingSheet] = useState(false);
    const [togglingWallet, setTogglingWallet] = useState(false);
    const [thisMonthWalletVisible, setThisMonthWalletVisible] = useState(false);

    const [tabState, setTabState] = useState('final-amount'); // ['final-amount','paid-amount']

    const { loading: exportLiveLoader, requestDownload: requestDownloadLive, DownloadPasswordModal: DownloadPasswordModalLive } = useDownloadWithPassword();

    const handleLivePayoutExcelDownload = () => {
        if (!selectedMonth?.monthName) return;
        const parts = selectedMonth.monthName.trim().split(/\s+/);
        const month = parts[0];
        const year = parts[1];
        if (!month || !year) return;
        const url = buildAdminApiUrl('admin/payout/export-book-month');
        const fileSlug = `${month}-${year}`.replace(/\s+/g, '-').toLowerCase();
        const params = { month, year };
        if (search && String(search).trim()) {
            params.search = String(search).trim();
        }
        requestDownloadLive(url, `payout-${fileSlug}-${dateFormat(new Date())}`, params);
    };

    const handleDownloadEditSettlement = () => {
        if (!selectedMonth?.monthName) return;
        const parts = selectedMonth.monthName.trim().split(/\s+/);
        const month = parts[0];
        const year = parts[1];
        if (!month || !year) return;
        const url = buildAdminApiUrl('admin/payout/settlement-sheet');
        requestDownloadLive(
            url,
            `settlement-edit-${month}-${year}-${dateFormat(new Date())}.xlsx`,
            { month, year },
            `Consultant Payout — Edit settlement ${selectedMonth.monthName}`
        );
    };

    const loadMonthLogs = async (month, year) => {
        if (!month || !year) {
            setSettlementLogs([]);
            return;
        }
        setSettlementLogsLoading(true);
        try {
            const response = await getSettlementLogs({ month, year });
            const data = response.data;
            setSettlementLogs(data?.success ? (data.result?.list || []) : []);
        } catch (error) {
            setSettlementLogs([]);
        } finally {
            setSettlementLogsLoading(false);
        }
    };

    const seedDrafts = (list) => {
        const next = {};
        (list || []).forEach((row) => {
            if (!row?._id) return;
            next[String(row._id)] = {
                paidAmount: row.paidAmount ?? row.coins ?? 0,
                payOutDate: toDateInput(row.payOutDate),
                transactionId: row.transactionId || '',
                remarks: row.remarks || '',
            };
        });
        setDrafts(next);
    };

    const patchDraft = (rowId, field, value) => {
        setDrafts((prev) => ({
            ...prev,
            [rowId]: {
                ...(prev[rowId] || {}),
                [field]: value,
            },
        }));
    };

    const selectedMonthParts = () => {
        const parts = String(selectedMonth?.monthName || '').trim().split(/\s+/);
        return { month: parts[0], year: parts[1] };
    };

    const handleReplaceMonthSheet = async (file) => {
        const { month, year } = selectedMonthParts();
        if (!file || !month || !year) return;
        try {
            setReplacingSheet(true);
            const formData = new FormData();
            formData.append('payOut', file);
            const response = await uploadExcelWithSettlement(formData, {
                replaceMonth: 'true',
                expectedMonth: month,
                expectedYear: year,
            });
            if (response.data?.success) {
                toastMessage(response.data.message || 'Sheet replaced. Payout now uses this latest data.', 'success', 'payoutList');
                getpayoutList({ month, year });
            } else {
                throw new Error(response.data?.message || 'Failed to replace sheet');
            }
        } catch (error) {
            toastMessage(error?.response?.data?.message || error.message || 'Failed to replace sheet', 'error', 'payoutList');
        } finally {
            setReplacingSheet(false);
        }
    };

    const buildSavePayload = (row) => {
        const id = String(row._id);
        const draft = drafts[id] || {};
        return {
            payoutId: id,
            paidAmount: draft.paidAmount,
            payOutDate: fromDateInput(draft.payOutDate),
            transactionId: draft.transactionId,
            remarks: draft.remarks,
        };
    };

    const handleSaveRow = async (row) => {
        try {
            setSavingRowId(String(row._id));
            const response = await updateSettlementRows({ rows: [buildSavePayload(row)] });
            if (response.data?.success) {
                toastMessage(response.data.message || 'Row saved', 'success', 'payoutList');
                const { month, year } = selectedMonthParts();
                getpayoutList({ month, year });
            } else {
                throw new Error(response.data?.message || 'Failed to save row');
            }
        } catch (error) {
            toastMessage(error?.response?.data?.message || error.message || 'Failed to save row', 'error', 'payoutList');
        } finally {
            setSavingRowId('');
        }
    };

    const handleSaveAllEdits = async () => {
        const rows = payoutList.filter((row) => row?._id).map(buildSavePayload);
        if (!rows.length) return;
        try {
            setSavingAll(true);
            const response = await updateSettlementRows({ rows });
            if (response.data?.success) {
                toastMessage(response.data.message || 'All edits saved', 'success', 'payoutList');
                const { month, year } = selectedMonthParts();
                getpayoutList({ month, year });
            } else {
                throw new Error(response.data?.message || 'Failed to save edits');
            }
        } catch (error) {
            toastMessage(error?.response?.data?.message || error.message || 'Failed to save edits', 'error', 'payoutList');
        } finally {
            setSavingAll(false);
        }
    };

    // useEffect(() => {
    //     setLocalStorage('payoutList', 'search', search)
    // }, [search])

    const [loader, showLoader, hideLoader] = useFullPageLoader()

    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        setActivePage(event)
    }

    //------------------consultant payout -listing-Api----------------------------------
    const getpayoutList = async (tempTimeSheet) => {
        try {
            showLoader()
            console.log('tempTimeSheet --> ', tempTimeSheet)
            const sendData = {
                page: activePage,
                limit: String(PAYOUT_MONTH_PAGE_SIZE),
                month: tempTimeSheet?.month,
                year: tempTimeSheet?.year
            }
            if (search) {
                sendData.search = search
                setActivePage(1)
            }
            if (fromDate) {
                sendData.fromDate = fromDate
            }
            if (toDate) {
                sendData.toDate = toDate
            }

            const response = await getConsultantPayoutForExactMonthApi(sendData)
            const data = response.data
            if (data.code === 200) {
                setTabState('final-amount')
                const list = data?.result?.finalList || []
                setPayoutList(list)
                setTotal(data?.result?.total || 0)
                setSettelmentInfo(data?.result?.prevPayoutTrack || null)
                const visibility = data?.result?.walletPayoutVisibility || null
                setThisMonthWalletVisible(Boolean(visibility?.isThisMonthVisible))
                if (visibility && typeof onWalletVisibilityChange === 'function') {
                    onWalletVisibilityChange({
                        showOnWallet: Boolean(visibility.showOnWallet),
                        month: visibility.month || null,
                        year: visibility.year || null,
                        period: visibility.period || null,
                    })
                }
                seedDrafts(list)
                loadMonthLogs(sendData.month, sendData.year)
                scrollToUp()
            } else {
                setPayoutList([])
                setTotal(0)
                setSettelmentInfo(null)
                setDrafts({})
                setSettlementLogs([])
                toastMessage(data.message, 'error', 'payoutList')
            }
        } catch (error) {
            setPayoutList([])
            setTotal(0)
            setSettelmentInfo(null)
            setDrafts({})
            setSettlementLogs([])
            toastMessage('No Payout Found!', 'error', 'payoutList')
        } finally {
            hideLoader()
        }
    }

    useEffect(() => {
        if (selectedMonth?.monthName) {
            const _currentTimeSheet = {
                month: selectedMonth?.monthName?.split(' ')[0],
                year: selectedMonth?.monthName?.split(' ')[1]
            };
            setEditMode(false);
            setExpandedLogId('');
            getpayoutList(_currentTimeSheet)
        }
    }, [search, (fromDate && toDate), selectedMonth?.monthName, activePage]);

    useEffect(() => {
        const selectedPeriod = String(selectedMonth?.monthName || '').trim().toLowerCase();
        const visiblePeriod = String(walletVisibility?.period || '').trim().toLowerCase();
        setThisMonthWalletVisible(Boolean(
            walletVisibility?.showOnWallet && selectedPeriod && selectedPeriod === visiblePeriod
        ));
    }, [walletVisibility, selectedMonth?.monthName]);

    const handleToggleWalletVisibility = async () => {
        const { month, year } = selectedMonthParts();
        if (!month || !year || togglingWallet) return;
        const nextVisible = !thisMonthWalletVisible;
        try {
            setTogglingWallet(true);
            const response = await setWalletPayoutVisibility({
                month,
                year,
                showOnWallet: nextVisible,
            });
            const data = response.data;
            if (data?.success) {
                const result = data.result || {};
                setThisMonthWalletVisible(Boolean(result.showOnWallet && String(result.period || '').toLowerCase() === `${month} ${year}`.toLowerCase()));
                if (typeof onWalletVisibilityChange === 'function') {
                    onWalletVisibilityChange(result);
                }
                toastMessage(
                    data.message || (nextVisible
                        ? `Consultant wallet will show ${month} ${year} payout`
                        : 'Consultant wallet payout details are hidden'),
                    'success',
                    'payoutList'
                );
            } else {
                throw new Error(data?.message || 'Failed to update wallet visibility');
            }
        } catch (error) {
            toastMessage(error?.response?.data?.message || error.message || 'Failed to update wallet visibility', 'error', 'payoutList');
        } finally {
            setTogglingWallet(false);
        }
    };

    return (
        <>
            {loader}
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                {exportLiveLoader ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: '600' }}>
                        <CircularProgress size={15} />
                        <span>Fetching, Converting, Downloading...</span>
                    </div>
                ) : (
                    <button
                        type="button"
                        onClick={handleLivePayoutExcelDownload}
                        style={payoutNativeBtnStyle({ bg: '#15803d', color: '#fff', border: '#166534' })}
                    >
                        Download selected month (Excel)
                    </button>
                )}
            </div>
            <div
                style={{
                    marginTop: 16,
                    padding: 16,
                    border: '1px solid #fecaca',
                    borderRadius: 10,
                    background: '#fff7f7',
                }}
            >
                <div style={{ fontWeight: 700, color: '#9f1239', marginBottom: 8 }}>
                    {selectedMonth?.monthName || 'This month'} settlement
                </div>
                <div style={{ fontSize: 13, color: '#57534e', marginBottom: 8 }}>
                    Edit paid amounts in the table below, or re-upload the complete sheet if a wrong file was uploaded.
                    Previous (wrong) and current (correct) files stay listed. Remaining always uses the latest saved data.
                    Turn <b>Show on consultant wallet</b> ON to display this month&apos;s payment amount, date, and cheque/UTR on the consultant app wallet. Only one month can be ON. If a consultant has no payout row, the app shows --.
                </div>
                <div style={{ fontSize: 12, color: '#78716c', marginBottom: 12 }}>
                    {settelmentInfo?.version ? `Version ${settelmentInfo.version}` : 'No sheet yet'}
                    {settelmentInfo?.lastEditedByName || settelmentInfo?.uploadedByName
                        ? ` · last edited by ${settelmentInfo.lastEditedByName || settelmentInfo.uploadedByName}`
                        : ''}
                    {settelmentInfo?.lastEditedAt
                        ? ` · ${dateFormatWithTime(settelmentInfo.lastEditedAt)}`
                        : ''}
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
                    <button
                        type="button"
                        onClick={handleToggleWalletVisibility}
                        disabled={togglingWallet}
                        style={payoutNativeBtnStyle(thisMonthWalletVisible
                            ? { bg: '#15803d', color: '#fff', border: '#166534', disabled: togglingWallet }
                            : { bg: '#fff', color: '#166534', border: '#86efac', disabled: togglingWallet })}
                    >
                        {togglingWallet
                            ? 'Updating wallet…'
                            : thisMonthWalletVisible
                                ? 'Consultant wallet: ON'
                                : 'Show on consultant wallet'}
                    </button>
                    <button
                        type="button"
                        onClick={() => setEditMode((v) => !v)}
                        style={payoutNativeBtnStyle(editMode
                            ? { bg: '#be123c', color: '#fff', border: '#9f1239' }
                            : { bg: '#fff1f2', color: '#be123c', border: '#fda4af' })}
                    >
                        {editMode ? 'Close edit' : 'Edit this month data'}
                    </button>
                    {editMode ? (
                        <button
                            type="button"
                            onClick={handleSaveAllEdits}
                            disabled={savingAll || !payoutList.length}
                            style={payoutNativeBtnStyle({
                                bg: '#15803d',
                                color: '#fff',
                                border: '#166534',
                                disabled: savingAll || !payoutList.length,
                            })}
                        >
                            {savingAll ? 'Saving…' : 'Save all edits'}
                        </button>
                    ) : null}
                    <button
                        type="button"
                        onClick={handleDownloadEditSettlement}
                        style={payoutNativeBtnStyle({ bg: '#eff6ff', color: '#1d4ed8', border: '#93c5fd' })}
                    >
                        Download current sheet
                    </button>
                    <label
                        style={{
                            ...payoutNativeBtnStyle({
                                bg: '#fff7ed',
                                color: '#9a3412',
                                border: '#fdba74',
                                disabled: replacingSheet,
                            }),
                            margin: 0,
                        }}
                    >
                        {replacingSheet ? 'Replacing sheet…' : 'Re-upload complete sheet'}
                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            disabled={replacingSheet}
                            style={{ display: 'none' }}
                            onChange={(e) => {
                                const file = e.target.files && e.target.files[0];
                                e.target.value = '';
                                if (file) handleReplaceMonthSheet(file);
                            }}
                        />
                    </label>
                </div>
                {(settelmentInfo?.sheetVersions || []).length ? (
                    <div style={{ display: 'grid', gap: 8 }}>
                        {settelmentInfo.sheetVersions.map((version) => {
                            const isCurrent = version.status === 'current';
                            return (
                                <div
                                    key={`${version.version}-${version.createdAt || version.sheetUrl}`}
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        gap: 12,
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        padding: 12,
                                        borderRadius: 8,
                                        border: isCurrent ? '1px solid #86efac' : '1px solid #fdba74',
                                        background: isCurrent ? '#f0fdf4' : '#fff7ed',
                                    }}
                                >
                                    <div>
                                        <div style={{ fontWeight: 700, color: isCurrent ? '#166534' : '#9a3412' }}>
                                            {isCurrent
                                                ? 'Current / correct sheet — used for payout remaining'
                                                : 'Previous / wrong upload — replaced, not used for calculation'}
                                            <span style={{ marginLeft: 8, fontWeight: 600, color: isCurrent ? '#166534' : '#9a3412' }}>
                                                v{version.version}
                                            </span>
                                        </div>
                                        <div style={{ fontSize: 12, color: '#57534e', marginTop: 4 }}>
                                            {version.adminName ? `${version.adminName} · ` : ''}
                                            {version.createdAt ? dateFormatWithTime(version.createdAt) : '—'}
                                            {version.totalPaid != null ? ` · paid ₹${Number(version.totalPaid).toFixed(2)}` : ''}
                                            {version.totalPending != null ? ` · remaining ₹${Number(version.totalPending).toFixed(2)}` : ''}
                                        </div>
                                    </div>
                                    <SettlementSheetLink href={version.sheetUrl} tone={isCurrent ? 'current' : 'replaced'}>
                                        {isCurrent ? 'Open current file' : 'Open previous / wrong file'}
                                    </SettlementSheetLink>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{ fontSize: 13, color: '#78716c' }}>
                        {settelmentInfo?.isSettlementComplete
                            ? 'Sheet uploaded. Use Edit this month data or re-upload a corrected file.'
                            : 'No sheet uploaded for this month yet. Re-upload complete sheet to add one.'}
                    </div>
                )}
            </div>
            <div style={{ margin: '12px 0 16px', padding: 12, border: '1px solid #e5e7eb', borderRadius: 8, background: '#f8fafc' }}>
                <div style={{ fontWeight: 700, marginBottom: 8, color: '#0f172a' }}>
                    {selectedMonth?.monthName || 'This month'} edit logs
                </div>
                {settlementLogsLoading ? (
                    <div style={{ fontSize: 13, color: '#64748b' }}>Loading logs...</div>
                ) : settlementLogs.length ? (
                    <table style={{ width: '100%', fontSize: 13 }}>
                        <thead>
                            <tr>
                                <th align="left">When</th>
                                <th align="left">Action</th>
                                <th align="left">Status</th>
                                <th align="left">Admin</th>
                                <th align="left">Summary</th>
                                <th align="left">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {settlementLogs.map((log) => {
                                const logId = String(log._id);
                                const isOpen = expandedLogId === logId;
                                const changes = Array.isArray(log.rowChanges) ? log.rowChanges : [];
                                return (
                                    <React.Fragment key={logId}>
                                        <tr>
                                            <td>{dateFormatWithTime(log.createdAt)}</td>
                                            <td>{log.action}</td>
                                            <td>{log.status === 'replaced' ? 'Previous / replaced' : 'Current'}</td>
                                            <td>{log.adminName || '—'}{log.adminEmail ? ` (${log.adminEmail})` : ''}</td>
                                            <td>
                                                Rows {log.summary?.totalRows || 0}
                                                {log.summary?.updatedCount != null ? `, updated ${log.summary.updatedCount}` : ''}
                                                {`, remaining ₹${Number(log.summary?.totalPending || 0).toFixed(2)}`}
                                            </td>
                                            <td>
                                                {changes.length ? (
                                                    <button
                                                        type="button"
                                                        onClick={() => setExpandedLogId(isOpen ? '' : logId)}
                                                        style={payoutNativeBtnStyle({ bg: '#fff', color: '#334155', border: '#cbd5e1' })}
                                                    >
                                                        {isOpen ? 'Hide' : `View ${changes.length}`}
                                                    </button>
                                                ) : '—'}
                                            </td>
                                        </tr>
                                        {isOpen ? (
                                            <tr>
                                                <td colSpan={6} style={{ background: '#fff', padding: 8 }}>
                                                    <table style={{ width: '100%', fontSize: 12 }}>
                                                        <thead>
                                                            <tr>
                                                                <th align="left">Consultant</th>
                                                                <th align="left">Change</th>
                                                                <th align="left">Paid</th>
                                                                <th align="left">Remaining</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {changes.map((change, idx) => (
                                                                <tr key={`${change.consultantId || idx}`}>
                                                                    <td>{change.name || '—'}</td>
                                                                    <td>{change.changeType || '—'}</td>
                                                                    <td>
                                                                        {Number(change.before?.paidAmount || 0).toFixed(2)}
                                                                        {' → '}
                                                                        {Number(change.after?.paidAmount || 0).toFixed(2)}
                                                                    </td>
                                                                    <td>
                                                                        {Number(change.before?.pendingBalance || 0).toFixed(2)}
                                                                        {' → '}
                                                                        {Number(change.after?.pendingBalance || 0).toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        ) : null}
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                ) : (
                    <div style={{ fontSize: 13, color: '#64748b' }}>No edit logs for this month yet.</div>
                )}
            </div>
            <div style={{ marginTop: 24 }}>
                <div className="">
                    <div className="search_lg_size userSearch" style={{ position: 'relative' }}>
                        <input
                            type="search"
                            className={`form-control ${search && 'active'}`}
                            placeholder="Search"
                            value={search || ''}
                            style={{ '--color': '#FF8989' }}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
                <div className="content-table">
                    <table>
                        <thead>
                            <tr>
                                <th>USER ID</th>
                                <th>USER NAME</th>
                                <th>BANK NAME</th>
                                <th>PAY MONTH</th>
                                <th>AC_NO.</th>
                                <th>IFSC CODE</th>
                                <th>THIS MONTH PAYABLE</th>
                                <th>PREV +/- (ADD / DEDUCT)</th>
                                <th>FINAL PAYABLE</th>
                                <th>AMOUNT F</th>
                                <th>THIS MONTH +/-</th>
                                <th>NEXT MONTH +/-</th>
                                <th>PAY DATE</th>
                                <th>PAY_UTR/REF NO.</th>
                                <th>REMARKS</th>
                                {editMode ? <th>SAVE</th> : null}
                            </tr>
                        </thead>
                        <tbody>
                            {payoutList.length > 0 ? (
                                payoutList.map((user, index) => {
                                    const rowId = user?._id ? String(user._id) : '';
                                    const draft = drafts[rowId] || {};
                                    const paidNow = Number(draft.paidAmount ?? user?.paidAmount ?? user?.coins ?? 0);
                                    const remainingNow = Number((Number(user?.finalPayableAmount || 0) - paidNow).toFixed(2));
                                    const remainingShown = remainingNow;
                                    return <tr key={rowId || `${activePage}-${index}`}>
                                        <td>{user?.userId || user?.consultantUserId || user?.consultantId || '---'}</td>
                                        <td>{user.name || '---'}</td>
                                        <td>{user?.bankName || '---'}</td>
                                        <td>{user?.monthOfPayOut || user?.period || monthFormat(user?.paymentDate) || '---'}</td>
                                        <td>{user?.accountNumber || '---'}</td>
                                        <td>{user?.ifsc || '---'}</td>
                                        <td>{roundedAmountWithInr(user?.currentPeriodPayableAmount)}</td>
                                        <td style={{ color: adjustmentColor(user?.carryForwardBalance), fontWeight: 600 }}>
                                            {signedAmountWithInr(user?.carryForwardBalance)}
                                            {Number(user?.carryForwardBalance || 0) !== 0 && user?.carryForwardFromPeriod
                                                ? ` (${Number(user.carryForwardBalance) > 0 ? 'add' : 'deduct'} ${user.carryForwardFromPeriod})`
                                                : ''}
                                        </td>
                                        <td>{roundedAmountWithInr(user?.finalPayableAmount)}</td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    value={draft.paidAmount ?? ''}
                                                    onChange={(e) => patchDraft(rowId, 'paidAmount', e.target.value)}
                                                    style={{ width: 110, padding: '6px 8px', border: '1px solid #fda4af', borderRadius: 6 }}
                                                />
                                            ) : roundedAmountWithInr(user?.coins)}
                                        </td>
                                        <td style={{ color: adjustmentColor(remainingShown), fontWeight: 600 }}>
                                            {signedAmountWithInr(remainingShown)}
                                            {adjustmentHint(remainingShown) ? ` (${adjustmentHint(remainingShown)})` : ''}
                                        </td>
                                        <td>
                                            {user?.pendingGoesToPeriod || 'Next month'}
                                            {Number(remainingShown) !== 0
                                                ? ` · ${signedAmountWithInr(remainingShown)}`
                                                : ''}
                                        </td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="date"
                                                    value={draft.payOutDate || ''}
                                                    onChange={(e) => patchDraft(rowId, 'payOutDate', e.target.value)}
                                                    style={{ padding: '6px 8px', border: '1px solid #fda4af', borderRadius: 6 }}
                                                />
                                            ) : (dateFormatWithTime(user?.payOutDate) || '---')}
                                        </td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    value={draft.transactionId || ''}
                                                    onChange={(e) => patchDraft(rowId, 'transactionId', e.target.value)}
                                                    style={{ width: 140, padding: '6px 8px', border: '1px solid #fda4af', borderRadius: 6 }}
                                                />
                                            ) : (user?.transactionId || '---')}
                                        </td>
                                        <td>
                                            {editMode ? (
                                                <input
                                                    type="text"
                                                    value={draft.remarks || ''}
                                                    onChange={(e) => patchDraft(rowId, 'remarks', e.target.value)}
                                                    style={{ width: 140, padding: '6px 8px', border: '1px solid #fda4af', borderRadius: 6 }}
                                                />
                                            ) : (user?.remarks || '---')}
                                        </td>
                                        {editMode ? (
                                            <td>
                                                <button
                                                    type="button"
                                                    disabled={!rowId || savingRowId === rowId}
                                                    onClick={() => handleSaveRow(user)}
                                                    style={payoutNativeBtnStyle({
                                                        bg: '#15803d',
                                                        color: '#fff',
                                                        border: '#166534',
                                                        disabled: !rowId || savingRowId === rowId,
                                                    })}
                                                >
                                                    {savingRowId === rowId ? 'Saving' : 'Save'}
                                                </button>
                                            </td>
                                        ) : null}
                                    </tr>
                                })
                            ) : (
                                <NotFound
                                    cols={editMode ? 17 : 16}
                                    msg="Payout not found!"
                                    icon={NOT_FOUND}
                                    loader={loader}
                                />
                            )}
                        </tbody>
                    </table>
                </div>
                {total > PAYOUT_MONTH_PAGE_SIZE ? (
                    <div className="pagination-wrapper">
                        <div className="Pagination">
                            <Pagination
                                activePage={activePage}
                                previousLabel={'previous'}
                                nextLabel={'next'}
                                itemsCountPerPage={PAYOUT_MONTH_PAGE_SIZE}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                hideDisabled={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
            <DownloadPasswordModalLive />
        </>
    )
} 
